import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum PatientsScheduledFilterEnum {
    AllPatients = 0,
    Assigned = 1,
    Unassigned = 2
}

export class PatientsScheduledFilterClass extends EnumWithDescription<PatientsScheduledFilterEnum> {
    public readonly enum = PatientsScheduledFilterEnum;
    public readonly enumName: string = "PatientsScheduledFilterEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<PatientsScheduledFilterEnum>> = new Map([
        [
            "AllPatients",
            {
                value: PatientsScheduledFilterEnum.AllPatients,
                name: "All Schedule Types"
            }
        ],
        [
            "Assigned",
            {
                value: PatientsScheduledFilterEnum.Assigned,
                name: "Assigned"
            }
        ],
        [
            "Unassigned",
            {
                value: PatientsScheduledFilterEnum.Unassigned,
                name: "Unassigned"
            }
        ]
    ]);
}

export const PatientsScheduledFilter = new PatientsScheduledFilterClass();
